import React, { useState, useEffect, useContext, useCallback } from 'react';
import AccordionContext from 'react-bootstrap/AccordionContext';
import ProfileNav from '../SideNav';
import { Button, Container, Accordion, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axios from 'axios';

import CartCtx from '../../CartCtx';
import "../../../scss/components/pages/profile/profile.scss";
import { getFormatterCount } from '../../cart/utils';
import { isIterableArray } from '../../block-slider/utils';

function ContextAwareToggle({ children, eventKey }) {
    const currentEventKey = useContext(AccordionContext);
    const isCurrentEventKey = currentEventKey === eventKey;

    return (
        <div className={`order-header__wrap flex ${isCurrentEventKey ? 'open' : ''}`}>
            {children}
        </div>
    );
}

const PagePOrders = () => {
    const context = useContext(CartCtx);

    const [orders, setOrders] = useState([]);
    const [pageData, setPageData] = useState({});
    const [page, setPage] = useState(1);

    const fetchOrders = useCallback((pageNum = page) => {
        axios.post(`${process.env.REACT_APP_API_BASE}/cabinet/my-orders`, {
            jwt: localStorage.getItem('galaxy-token'),
            page: pageNum,
        })
            .then(response => {
                setOrders(response.data.data.order_list || []);
                setPageData(response.data.data.pages || {});
            })
            .catch(err => {
                console.error(err);
            });
    }, [page]);

    useEffect(() => {
        fetchOrders(page);
    }, [page, fetchOrders]);

    const changePage = (num) => {
        setPage(Number(num));
    };

    // Список ТЦ из context (как в Checkout)
    const getTcList = useCallback(() => {
        const list = [];
        const raw = context?.tcData?.list;

        if (Array.isArray(raw)) {
            raw.forEach(group => {
                if (Array.isArray(group.ts_list)) {
                    group.ts_list.forEach(tc => {
                        list.push({
                            tcId: tc.id,
                            tcName: tc.address,
                        });
                    });
                }
            });
        }

        return list;
    }, [context?.tcData?.list]);

    /**
     * Адрес доставки / самовывоза
     * Новая логика (Checkout):
     *   delivery === '1'  → самовывоз, ТЦ по id_center
     *   delivery === '99' → доставка по city / address / home / flat
     */
    const getAddressString = useCallback((item) => {
        const delivery = String(item.delivery);

        // Курьерская доставка
        if (delivery === '99') {
            const parts = [];
            if (item.city) parts.push(item.city);
            if (item.address) parts.push(item.address);
            if (item.home) parts.push(`д. ${item.home}`);
            if (item.flat) parts.push(`кв. ${item.flat}`);

            return parts.length > 0
                ? `Доставка: ${parts.join(', ')}`
                : 'Доставка';
        }

        // Самовывоз — ищем ТЦ по id_center или по delivery
        const tcList = getTcList();
        const tcId = item.id_center
        const tc = tcList.find(t => String(t.tcId) === String(tcId));

        if (tc?.tcName) {
            return `Самовывоз: ${tc.tcName}`;
        }

        return '';
    }, [getTcList]);

    const buildPages = () => {
        const lastPage = Number(pageData.lastPage) || 0;
        if (lastPage <= 1) return null;

        const pages = [];
        for (let n = 1; n <= lastPage; n++) {
            pages.push(n);
        }

        return pages.map(num => (
            <li
                className={`pagination__item ${Number(page) === num ? 'active' : ''}`}
                key={num}
                onClick={() => changePage(num)}
            >
                <a
                    href="!#"
                    className="link"
                    onClick={(e) => e.preventDefault()}
                >
                    <b>{num}</b>
                </a>
            </li>
        ));
    };

    return (
        <main className="page-profile">
            <Container>
                <ProfileNav />
                <section className="prof-main pp-orders">
                    <div className="breadcrumbs">
                        <div className="breadcrumbs__item">
                            <h1>Личный кабинет</h1>
                        </div>
                        <div className="breadcrumbs__item">
                            <h2>Заказы</h2>
                        </div>
                    </div>

                    <div className="prof-content pp-profile">
                        <div className="prof-content__header flex">
                            <p>
                                Всего заказов: <span>{pageData.total ?? 0}</span>
                            </p>
                        </div>

                        <div className="prof-content__body">
                            <Accordion className="orders">
                                {orders.length > 0 &&
                                    orders.map((item, index) => (
                                        <Card className="order" key={item.order_numb || index}>
                                            <Card.Header className="order-header">
                                                <ContextAwareToggle eventKey={`${index}`}>
                                                    <Accordion.Toggle
                                                        as={Button}
                                                        variant="simple"
                                                        className="order-btn"
                                                        eventKey={`${index}`}
                                                    >
                                                        <i className="i-arrow" />
                                                        <p>
                                                            Заказ #<span>{item.order_numb}</span>
                                                        </p>
                                                    </Accordion.Toggle>

                                                    <div className="order-header__main">
                                                        <div className="order-header__items">
                                                            {item.products?.map((product, pIndex) =>
                                                                product.status === 'show' ? (
                                                                    <div className="item" key={product.id || pIndex}>
                                                                        <img
                                                                            src={
                                                                                process.env.REACT_APP_BACKEND +
                                                                                'uploads/products/main/' +
                                                                                product.photo_url
                                                                            }
                                                                            alt=""
                                                                        />
                                                                    </div>
                                                                ) : null
                                                            )}
                                                        </div>

                                                        <div className="order-header__info">
                                                            <div className="order-header__total">
                                                                <p>
                                                                    Товаров <span>{item.count_products}</span> на сумму:
                                                                </p>
                                                                <b className="i-rub">
                                                                    {Number(item.order_summ).toLocaleString('ru')}
                                                                </b>
                                                            </div>
                                                            <div className="order-header__date">
                                                                {item.created_at}
                                                            </div>
                                                            <div className="order-header__status">
                                                                <div
                                                                    className={`status ${item.order_status === 'Заказ выполнен'
                                                                        ? 'complete'
                                                                        : 'taken'
                                                                        }`}
                                                                >
                                                                    <span>{item.order_status}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </ContextAwareToggle>
                                            </Card.Header>

                                            <Accordion.Collapse eventKey={`${index}`} className="order-body">
                                                <Card.Body className="order-body__wrap">
                                                    <div className="order-main">
                                                        <div className="order-main__status">
                                                            <div
                                                                className={`status ${item.order_status === 'Заказ выполнен'
                                                                    ? 'complete'
                                                                    : 'taken'
                                                                    }`}
                                                            >
                                                                <p>Статус</p>
                                                                <h3>{item.order_status}</h3>
                                                            </div>
                                                        </div>

                                                        <Accordion className="order-info">
                                                            <Card className="order-infull">
                                                                <Card.Header className="order-infull__header">
                                                                    <ContextAwareToggle eventKey="900">
                                                                        <Accordion.Toggle
                                                                            as={Button}
                                                                            variant="simple"
                                                                            className="order-btn"
                                                                            eventKey="900"
                                                                        >
                                                                            <span>Полная информация о заказе</span>
                                                                            <i className="i-arrow" />
                                                                        </Accordion.Toggle>
                                                                    </ContextAwareToggle>
                                                                </Card.Header>
                                                                <Accordion.Collapse
                                                                    eventKey="900"
                                                                    className="order-infull__body"
                                                                >
                                                                    <Card.Body className="info-flex">
                                                                        <div className="line">
                                                                            <b>ФИО</b>
                                                                            <p>{item.name}</p>
                                                                        </div>
                                                                        <div className="line">
                                                                            <b>Телефон</b>
                                                                            <p>{item.phone}</p>
                                                                        </div>
                                                                        <div className="line">
                                                                            <b>E-mail</b>
                                                                            <p>{item.email}</p>
                                                                        </div>
                                                                        <div className="line">
                                                                            <b>Способ оплаты</b>
                                                                            <p>
                                                                                {item.payment === '1'
                                                                                    ? 'Наличные'
                                                                                    : 'Безналичный расчёт'}
                                                                            </p>
                                                                        </div>
                                                                        <div className="line">
                                                                            <b>Адрес</b>
                                                                            <p style={{ paddingLeft: 15 }}>{getAddressString(item)}</p>
                                                                        </div>
                                                                        <div className="line">
                                                                            <b>Комментарий</b>
                                                                            <p>{item.comment_user}</p>
                                                                        </div>
                                                                    </Card.Body>
                                                                </Accordion.Collapse>
                                                            </Card>

                                                            <Card className="order-infull">
                                                                <Card.Header className="order-infull__header">
                                                                    <ContextAwareToggle eventKey="901">
                                                                        <Accordion.Toggle
                                                                            as={Button}
                                                                            variant="simple"
                                                                            className="order-btn"
                                                                            eventKey="901"
                                                                        >
                                                                            <span>История заказа</span>
                                                                            <i className="i-arrow" />
                                                                        </Accordion.Toggle>
                                                                    </ContextAwareToggle>
                                                                </Card.Header>
                                                                <Accordion.Collapse
                                                                    eventKey="901"
                                                                    className="order-history__body"
                                                                >
                                                                    <Card.Body className="info-flex">
                                                                        <ul className="history-list">
                                                                            {item.history?.map((hist, hIndex) => (
                                                                                <li
                                                                                    className="history-list__item"
                                                                                    key={hIndex}
                                                                                >
                                                                                    <b className="date">{hist.date}</b>
                                                                                    <ul className="history-list__statuses">
                                                                                        {hist.item?.map((st, sIndex) => (
                                                                                            <li
                                                                                                className="history-list__status"
                                                                                                key={sIndex}
                                                                                            >
                                                                                                <span className="time">
                                                                                                    {st.time}
                                                                                                </span>
                                                                                                <p className="status complete">
                                                                                                    {st.name}
                                                                                                </p>
                                                                                            </li>
                                                                                        ))}
                                                                                    </ul>
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    </Card.Body>
                                                                </Accordion.Collapse>
                                                            </Card>
                                                        </Accordion>
                                                    </div>

                                                    <div className="order-products">
                                                        <div className="order-products__wrap">
                                                            <div className="cart-items">
                                                                <div className="cart-items__wrap">
                                                                    {item.products?.map((product, pIndex) =>
                                                                        product.status === 'show' ? (
                                                                            <div
                                                                                className="cart-item"
                                                                                key={product.id || pIndex}
                                                                            >
                                                                                <div className="products-image">
                                                                                    <Link
                                                                                        className="products-image__link"
                                                                                        to={`/product/${product.name_slug}`}
                                                                                    >
                                                                                        <img
                                                                                            src={
                                                                                                process.env.REACT_APP_BACKEND +
                                                                                                'uploads/products/main/' +
                                                                                                product.photo_url
                                                                                            }
                                                                                            alt=""
                                                                                        />
                                                                                    </Link>
                                                                                </div>
                                                                                <div className="products-info">
                                                                                    <div className="products-info__top">
                                                                                        <Link
                                                                                            className="products-title"
                                                                                            to={`/product/${product.name_slug}`}
                                                                                        >
                                                                                            {product.name}
                                                                                        </Link>
                                                                                    </div>
                                                                                    <div className="products-info__bottom">
                                                                                        <div className="products-price in-stock">
                                                                                            <div className="products-price__wrap">
                                                                                                <p className="product-header__code">
                                                                                                    Код:{' '}
                                                                                                    <span>
                                                                                                        {product.articule && product.articule}
                                                                                                    </span>
                                                                                                </p>
                                                                                                <div className="products-price__main">
                                                                                                    <span className="price i-rub">
                                                                                                        {Number(
                                                                                                            product.price
                                                                                                        ).toLocaleString(
                                                                                                            'ru'
                                                                                                        )}
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="products-sum">
                                                                                            <div className="products-qty">
                                                                                                {getFormatterCount(product.count, product?.step)} {product?.unit ? `/${product?.unit}` : 'шт.'}
                                                                                            </div>
                                                                                            <div className="products-sum__total">
                                                                                                <span className="price i-rub">
                                                                                                    {Number(
                                                                                                        product.summ
                                                                                                    ).toLocaleString(
                                                                                                        'ru'
                                                                                                    )}
                                                                                                </span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        ) : null
                                                                    )}
                                                                    {
                                                                        isIterableArray(item?.services) ?
                                                                            item.services.map(service => (
                                                                                <div className="cart-item">

                                                                                    <div style={{ width: '100%' }}>
                                                                                        <div className="products-title">
                                                                                            {service.name}
                                                                                        </div>
                                                                                        <div className="products-info__bottom">
                                                                                            {
                                                                                                service.article &&
                                                                                                <p className="product-header__code">
                                                                                                    Код:{' '}
                                                                                                    <span>
                                                                                                        {service.article}
                                                                                                    </span>
                                                                                                </p>
                                                                                            }
                                                                                        </div>
                                                                                        <div style={{
                                                                                            display: 'flex',
                                                                                            alignItems: 'center'
                                                                                        }}>
                                                                                            <div className="products-price">
                                                                                                <div className="products-price__main">
                                                                                                    <span className="price i-rub">
                                                                                                        {Number(service.price).toLocaleString('ru')}
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="products-sum " style={{ flex: 1 }}>
                                                                                                <div className="products-qty">
                                                                                                    {service?.quantity ? `Кол-во: ${service?.quantity}` : ''}
                                                                                                </div>
                                                                                                <div className="products-sum__total">
                                                                                                    <span className="price i-rub">
                                                                                                        {Number(service.sum).toLocaleString('ru')}
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            ))
                                                                            :
                                                                            <></>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="order-products__footer">
                                                            <p>Всего к оплате:</p>
                                                            <span className="i-rub">
                                                                {Number(item.order_summ).toLocaleString('ru')}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>
                                    ))}
                            </Accordion>
                        </div>

                        <div className="catalog-list__navigation">
                            <div className="pagination">
                                <ul className="pagination__wrap">
                                    {pageData?.lastPage > 1 ? buildPages() : null}
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
            </Container>
        </main>
    );
};

export default PagePOrders;